import StyledSvg from 'icons/StyledSvg';
import { IconProps } from 'icons/types';

// This icon is for the "-->" arrow
export const RightArrow = ({ color, size = '33', height = '15' }: IconProps) => {
  return (
    <StyledSvg
      width={size}
      height={height}
      viewBox="0 0 35 15"
      color={color || 'currentColor'}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0,7.5h33 M27,1.5l6,6l-6,6" stroke={color || 'currentColor'} strokeWidth="1.5" />
    </StyledSvg>
  );
};
